import { Grid, makeStyles, Typography } from "@material-ui/core";
import { useEffect, useState } from "react";
import { lang } from "../../i18nLang";

const useStyles = makeStyles({
  loading: { position: "relative", transform: "translateY(200px)" },
  frame: {
    zIndex: 1,
    border: 0,
    overflow: "hidden",
    margin: "0 auto",
    "& .kpimetric .valueLabel": {
      fontWeight: 700,
    },
  },
});

const urlDefault = "https://lookerstudio.google.com/embed/reporting/";
const chartsUrl = {
  contract: `59fe33ea-6c89-4810-b2a5-9183203b7316/page/p_d655i50nrc`,
  budget: `daff7186-0413-4596-8945-833424028495/page/p_rsndvg1nrc`,
  budgetExceeded: `c9b0fc0b-d2b9-48d3-bfbd-26f3fded8c49/page/p_9i347jkktc`,
};

const IndicatorChart = ({
  title,
  type,
  parameters,
}: {
  title: string;
  type: "contract" | "budget";
  parameters;
}) => {
  const classes = useStyles();
  const [url, setUrl] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setUrl(createUrl());

    function createUrl(): string {
      let chartType = verifyType(type);
      return urlDefault + chartsUrl[chartType] + "?" + getParams();
    }

    function verifyType(type): string {
      if (type === "budget") {
        if (parameters.realizedCost > parameters.executiveTotal)
          return "budgetExceeded";
      }
      return type;
    }

    function getParams() {
      const data = {
        "ds0.valorcontratado": parameters.contractTotal || 0,
        "ds0.valor_faturamento": parameters.billingTotal || 0,
        "ds0.saldo_a_faturar": parameters.balanceToBill || 0,
        "ds0.percentualfaturado": parameters.billingPercentual || 0,
        "ds0.valorexecutivo": parameters.executiveTotal || 0,
        "ds0.valoragregado": parameters.addedTotal || 0,
        "ds0.custorealizado": parameters.realizedCost || 0,
        "ds0.percentualagregado": parameters.addedPercentual || 0,
        "ds0.percentualrealizado": parameters.realizedPercentual || 0,
      };

      return `params=${encodeURI(JSON.stringify(data))}`;
    }
  }, [type, parameters]);

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      style={{ flexGrow: 1, minHeight: 460 }}
    >
      {isLoading && (
        <Typography variant="body1" className={classes.loading}>
          {`${lang("loading")}...`}
        </Typography>
      )}
      <iframe
        title={title}
        className={classes.frame}
        src={url}
        frameBorder="0"
        height={430}
        width={535}
        allowFullScreen
        scrolling="no"
        onLoad={() => setIsLoading(false)}
      ></iframe>
    </Grid>
  );
};

export default IndicatorChart;
